import type { FlowContextInterface, IChangeComponentGroup, IMovePayload } from 'contexts/FlowContext';
import { FlowActionTypes } from 'contexts/FlowContext';
import _ from 'lodash';

export const modelChangeCB = (sender, evt, ctx: FlowContextInterface | null) => {
  const { changes } = evt.getProperty('edit');

  // handel any child change
  changes.forEach(c => {
    if (c?.constructor.name === 'mxCollapseChange') {
      ctx?.dispatch({
        type: FlowActionTypes.TOGGLE_COLLAPSED,
        payload: {
          componentId: c.cell.value?.compId,
          collapsed: c.collapsed
        }
      });
    }

    if (
      c?.constructor.name === 'mxChildChange' &&
      c.previous &&
      c.parent &&
      c.previous.mxObjectId !== c.parent.mxObjectId &&
      c.child.value?.compId
    ) {
      /**
       * if c.previous not set it's a new component
       * if c.parent not set it's remove a component
       * if one of the .value?.comId's are not set, its the defaultParent
       */
      ctx?.dispatch({
        type: FlowActionTypes.CHANGE_GROUP,
        payload: {
          componentId: c.child.value.compId,
          targetGroupId: c.parent.value?.compId
        }
      } as IChangeComponentGroup);

      return;
    }

    // Move edge waypoints
    if (
      c?.constructor.name === 'mxGeometryChange' &&
      c.cell?.edge &&
      c.cell.source?.value?.key &&
      c.cell.source.parent?.value?.compId &&
      !c.cell.parent?.isContentLocked &&
      !_.isEqual(c.geometry.points, c.previous?.points)
    ) {
      ctx?.dispatch({
        type: FlowActionTypes.UPDATE_CONNECTION_WAYPOINTS,
        payload: c.cell.source?.parent?.value?.virtualConfigPath
          ? {
              flowSettingPath: c.cell.source.parent.value.virtualConfigPath,
              port: c.cell.source.value.key,
              waypoints: c.geometry.points || []
            }
          : {
              componentId: c.cell.source.parent.value.compId,
              port: c.cell.source.value.key,
              waypoints: c.geometry.points || []
            }
      });

      return;
    }

    // Component move
    if (
      c?.constructor.name !== 'mxGeometryChange' ||
      c.cell.edge ||
      (c.cell.collapsed && _.isEqualWith(c.geometry?.getPoint(), c.previous?.getPoint())) // don't trigger if size change of collapsed cell
    ) {
      return;
    }
    if (
      _.isEqualWith(c.geometry?.getPoint(), c.previous?.getPoint()) &&
      c.geometry.height === c.previous.height &&
      c.geometry.width === c.previous.width
    ) {
      return;
    }

    const payload: IMovePayload = {
      compId: c.cell.value.compId,
      point: c.geometry.getPoint()
    };
    if (_.has(c, 'cell.value.editor.size')) {
      payload.size = { height: c.geometry.height as number, width: c.geometry.width as number };
    }

    // set by the virtualComponents for trigger and tail
    if (c.cell.value?.virtualConfigPath) {
      payload.flowSettingPath = c.cell.value.virtualConfigPath;
    }
    ctx?.dispatch({
      type: FlowActionTypes.TRANSLATE_COMPONENT,
      payload
    });
  });
};
